import type { Field, Predicate, Scalar } from '../predicate';
import { always, eq, eqStringLiteral, never } from '../predicate';

export const eqWhenTruthy = <TDoc>(field: Field<TDoc>, value: Scalar | null | undefined): Predicate<TDoc> =>
  value ? eq<TDoc>(field, value) : always<TDoc>();

export const eqWhenPresent = <TDoc>(field: Field<TDoc>, value: Scalar | null | undefined): Predicate<TDoc> =>
  value === null || value === undefined ? always<TDoc>() : eq<TDoc>(field, value);

export const eqStringLiteralWhenTruthy = <TDoc>(
  field: Field<TDoc>,
  value: string | null | undefined
): Predicate<TDoc> => (value ? eqStringLiteral<TDoc>(field, value) : always<TDoc>());

export const eqStringLiteralWhenPresent = <TDoc>(
  field: Field<TDoc>,
  value: string | null | undefined
): Predicate<TDoc> => (value === null || value === undefined ? always<TDoc>() : eqStringLiteral<TDoc>(field, value));

/** Callers set either the single-value scope or the grouped one; both together are honoured but never emitted today. */
export const groupedEqStringLiteralsWhenPresent = <TDoc>(
  field: Field<TDoc>,
  values: readonly string[] | null | undefined
): Predicate<TDoc> => {
  if (values === null || values === undefined) return always<TDoc>();
  if (values.length === 0) return never<TDoc>();

  // Raw `or` node, not or(): the combinator collapses a single operand and drops the
  // parentheses the legacy filter string always emits.
  return { kind: 'or', operands: values.map((value) => eqStringLiteral<TDoc>(field, value)) };
};
